  <div id="gen-loading" *ngIf="videoUploading" >
    <div class="loader-inner text-center">
        
         <img class="img-fluid logo mobile-hide-log" width="100px" src="https://app.funtelstudio.com/storage/uploads/settings/app_logo_U0iNFBBT69LqaizVZG7H2ofsuu4cFOVAfk2I6Vj7iprY1wOI4NaHDaCpRTg78zTD.png" alt="streamlab-image">
        <p class="mb-0 loading-content text-light mt-2">Uploading video, please wait...</p>
        <div class="loader-spinner"></div>
    </div>
</div>
<app-header></app-header>
<main class="container mx-auto px-4 lg:px-6 pb-20">
    <p class="alert alert-success" *ngIf="message">{{message}}</p>
    <form [formGroup]="storyForm" (ngSubmit)="onSubmit()">

        <!-- <div class="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-sm mb-6">
            <h2 class="text-lg font-bold mb-4">Add Media</h2>

            
            <div class="mb-6">
                <label class="block text-sm font-medium mb-2">Audio</label>

                
                <div class="mb-4">

                </div>

                
                <div class="mb-2">
                    <div class="flex">
                        <input type="text" formControlName="audio_link" placeholder="Or paste audio URL (SoundCloud, etc.)"
                            class="flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded focus:outline-none focus:ring-2 focus:ring-wattpad-primary focus:border-transparent dark:bg-gray-700">

                    </div>
                    <p class="text-sm text-gray-500">Audio link value: {{ storyForm.get('audio_link')?.value }}</p>

                </div>

            </div>

           
            <div>
  <label class="block text-sm font-medium mb-2">Video Link</label>

  
  <div class="flex mb-2">
    <input type="text" formControlName="video_link" placeholder="Paste YouTube or Vimeo link"
      class="flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded focus:outline-none focus:ring-2 focus:ring-wattpad-primary focus:border-transparent dark:bg-gray-700" readonly>
      
  </div>

  
  <div class="mb-4">
    <label class="block text-sm font-medium mb-2">Upload Video (mp4, mov)</label>
    <div class="flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded focus:outline-none focus:ring-2 focus:ring-wattpad-primary focus:border-transparent dark:bg-gray-700 ng-untouched ng-pristine ng-valid p-5 relative pointer">
        <div class="selectfile">Select File</div>
        <input type="file" accept="video/*" class="videofield" (change)="onVideoSelected($event)" />
    </div>
    

    

    
    <div *ngIf="videoUploadProgress !== null && !videoUploading" class="mt-2">
      <div class="w-full bg-gray-200 rounded h-2">
        <div [style.width.%]="videoUploadProgress" class="h-2 rounded bg-green-500"></div>
      </div>
      <p class="text-xs mt-1">{{ videoUploadProgress }}% uploaded</p>
    </div>

    
    <p *ngIf="uploadedVideoUrl" class="text-xs mt-2 text-green-600">
      Uploaded: <a [href]="uploadedVideoUrl" target="_blank">{{ uploadedVideoUrl }}</a>
    </p>
  </div>
</div>
        </div> -->
        <!-- Story Editor Section -->
        <div class="bg-white dark:bg-gray-800 rounded-lg shadow-sm mb-6">

            <!-- Part Title -->
            <div class="p-6 border-b border-gray-200 dark:border-gray-700">
                <input type="text" formControlName="story_title" placeholder="Untitled Part"
                    class="w-full text-2xl font-bold bg-transparent  focus:outline-none focus:ring-0 p-0">
            </div>

            <!-- Editor Content -->
            <editor formControlName="story_content" [init]="editorConfig"></editor>

        </div>

        <!-- Story Info Section (Moved to bottom) -->
        <!-- Story Info Section (Moved to bottom) -->
        <div class="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-sm">
            <div class="flex items-center justify-between">
                <div class="flex items-center space-x-4">


                </div>

                <div class="flex flex-wrap gap-3">
                    <button *ngIf="!isReadOnly" (click)="publishStory()"
                        class="pointer px-6 py-2 rounded-full font-medium bg-wattpad-primary text-white hover:bg-[#E5274B] transition-colors"
                        type="button">
                        <i class="fas fa-upload mr-2"></i> Publish
                    </button>
                    <button type="submit" *ngIf="!isReadOnly"
                        class="px-6 py-2 rounded-full font-medium border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                        <i class="fas fa-save mr-2"></i> Save Draft
                    </button>


                    <!-- <button id="previewBtn" class="px-6 py-2 rounded-full font-medium border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                        <i class="fas fa-eye mr-2"></i> Preview
                    </button> -->
                </div>
            </div>
        </div>
    </form>
</main>